module.exports = __webpack_public_path__ + "5070f54c04cac79cb3d9293ae4034d53.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/search.svg
// module id = ./app/images/search.svg
// module chunks = 3